import './App.css';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import {
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from './context/ThemeContext';
import RouteConfig from './RouteConfig';
import './scss/theme.scss';

function App() {
  return (
    <ThemeProvider>
      <RouteConfig />
    </ThemeProvider>
  );
}

export default App;
